/**
 * Picks which nav entry a path belongs to: the longest href the path matches.
 *
 * A plain `startsWith` check marks every prefix as active, so a section index
 * (`/resources`) stays highlighted while one of its children (`/resources/faq`)
 * is open. Taking the longest match instead means the child wins, and a nested
 * page (`/resources/videos/bonding`) still highlights its section.
 */
export function activeNavHref(pathname: string, hrefs: string[]): string | undefined {
    return hrefs
        .filter((href) => pathname === href || pathname.startsWith(`${href}/`))
        .sort((a, b) => b.length - a.length)[0];
}
